export function toTitleCase(segment: string): string {
  return segment
    .replace(/([a-z])([A-Z])/g, "$1 $2") // insert space before capital letters
    .replace(/^./, (str) => str.toUpperCase()); // capitalize the first letter
}

export function capitalizeFirst(segment: string): string {
  return segment.charAt(0).toUpperCase() + segment.slice(1);
}
